import React, { useState } from 'react';
import {
  facebook,
  instagram,
  linkedin,
  xing,
} from 'static/icons/social/default';
import {
  facebook as facebookHover,
  instagram as instagramHover,
  linkedin as linkedinHover,
  xing as xingHover,
} from 'static/icons/social/hover';

import * as S from './SocialStyles';

type ISocialButton = {
  src: string;
  srcHover: string;
  alt: string;
  href: string;
};

const SocialButtons: ISocialButton[] = [
  {
    src: facebook,
    srcHover: facebookHover,
    alt: 'facebook',
    href: 'https://www.facebook.com/Andersensoft/',
  },
  {
    src: instagram,
    srcHover: instagramHover,
    alt: 'instagram',
    href: 'https://www.instagram.com/andersencompany/',
  },
  {
    src: linkedin,
    srcHover: linkedinHover,
    alt: 'linkedin',
    href: 'https://linkedin.com/company/andersen-softwaredev',
  },
  {
    src: xing,
    srcHover: xingHover,
    alt: 'xing',
    href: 'https://www.xing.com/pages/andersen',
  },
];

const SocialButton = ({ src, alt, srcHover, href }: ISocialButton) => {
  const [isHover, setIsHover] = useState(false);
  const handleToggleIsHover = () => setIsHover((prev: boolean) => !prev);

  return (
    <S.SocialIconBoxStyled
      href={href}
      target='_blank'
      onTouchStart={handleToggleIsHover}
      onMouseEnter={handleToggleIsHover}
      onTouchEnd={handleToggleIsHover}
      onMouseLeave={handleToggleIsHover}
    >
      <img src={isHover ? srcHover : src} alt={alt} />
    </S.SocialIconBoxStyled>
  );
};

export const Social = () => (
  <S.SocialStyled>
    {SocialButtons.map((button) => (
      <SocialButton {...button} key={button.alt} />
    ))}
  </S.SocialStyled>
);
